<template lang="pug">
    tr

        // First Name
        td {{ item.fullName }}

        // Email
        td {{ item.email }}

        // Phone
        td(v-if="item.phone") {{ item.phone | phoneNumber }}
        td(v-else)

        // Status
        td
            status-component(v-if="item.isActive") {{ $t('managers.list.status.active')}}
            status-component.warningColor(v-else ) {{ $t('managers.list.status.inactive')}}

        // Role
        td.role {{ item.role }}

        // Actions
        td.px-0.text-xs-right

            // Edit manager button
            button-component(:action="edit" color="primary" icon="edit")

            // Delete manager button
            button-component(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import Status from '~components/Status';
    import phoneNumber from '~filters/Phone';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon,
            StatusComponent: Status
        },
        filters: {
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            ...mapActions('managers', ['deleteAccount']),

            /**
             * Edit manager
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.managers.edit',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete manager.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteAccount(this.item.id);

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .role
        text-transform: capitalize
</style>
